import {NumberUtil} from "base/utilities";
import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const SubaglomeracionInventarioTanquesSection = ({subaglomeracion}) => {
    return (
        <SectionCard title="Tanques">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Totais:"
                        value={NumberUtil.formatInteger(subaglomeracion.stats.tanques)}
                        tooltipText="Tanques totais da rede"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default SubaglomeracionInventarioTanquesSection;
